import { render, staticRenderFns } from "./pautageral_24.vue?vue&type=template&id=5de9c462&"
import script from "./pautageral_24.vue?vue&type=script&lang=js&"
export * from "./pautageral_24.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports